import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/Modal'
import { Text } from '@conexasaude/conexa-hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useStyles } from './styles'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useNavigation } from '@/hooks/useNavigation'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'

const AttendanceStartedModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()

  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()
  const styles = useStyles()
  const { logAnalyticsEvent } = useFirebaseContext()
  const navigate = useNavigation()

  const appointmentId = useCallMonitoringStore(state => state.appointmentId)

  const goAppointmentScheduledWithAnalytics = useCallback(() => {
    const currentAppointmentId = appointmentId || nextScheduled?.id
    const currentParams = appointmentId ? '?o=ep' : ''

    logAnalyticsEvent('Pac_Consulta_AcessarConsulta')
    closeModal()
    navigate(
      `/atendimento-agendado/sala-de-espera/${currentAppointmentId}${currentParams}`,
    )
  }, [
    appointmentId,
    closeModal,
    logAnalyticsEvent,
    navigate,
    nextScheduled?.id,
  ])

  const closeModalWithAnalytics = () => {
    logAnalyticsEvent('Pac_Consulta_Fechar')
    closeModal()
  }

  return (
    <Modal
      id="ATTENDANCE_STARTED"
      primaryActionLabel="Acessar consulta"
      primaryAction={goAppointmentScheduledWithAnalytics}
      negativeActionLabel="Fechar"
      negativeAction={closeModalWithAnalytics}
    >
      <div css={styles.wrapperModal}>
        <Text>Sua consulta começará em alguns minutos.</Text>
      </div>
    </Modal>
  )
}

export default AttendanceStartedModal
